export default __webpack_public_path__ + "static/media/lemontbotanique_background_s2.b29f100a.jpg";